import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-novice-expert',
  templateUrl: './disable-novice-expert.component.html',
  styleUrls: ['./disable-novice-expert.component.css'],
})
export class DisableNoviceExpertComponent {
  @Input() question!: Question;
}
